export default __webpack_public_path__ + "static/media/Ballroll_00226.a7da0b76.png";